import axios from 'axios';
import { BASE_URL } from '../../config/environmentConfig';
import { GET } from '../store/store-helper';

export interface IWebhookList {
	id: string;
	endpointUrl: string;
	eventName: string;
	subscriberKey: string;
	mid: string;
}

export const fetchWebhooksList = async (mid?: string, pid?: string): Promise<IWebhookList[]> => {
	try {
		let baseUrl = `${BASE_URL.WEBHOOKS}/Webhooks`;
		if (mid) {
			baseUrl = `${baseUrl}?mid=${mid}`;
		} else if (pid) {
			baseUrl = `${baseUrl}?pid=${pid}`;
		}
		const data = await GET({ pathname: baseUrl });

		return data || [];
	} catch (e) {
		console.log(e);
	}
};

export const fetchLogsList = (pageNumber): Promise<any> => {
	return axios
		.get(`${BASE_URL.WEBHOOKS}/webhooks/log`,{
			params: {
				limit: 10,
				pageNumber,
			}
		})
		.then(data => data);
};
